import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 p-10 text-center">
        <div className="flex justify-center mb-6">
          <Logo />
        </div>
        <XCircle className="w-12 h-12 text-slate-300 mx-auto mb-4" />
        <h1 className="text-xl font-bold text-brand-navy mb-2">Paiement annulé</h1>
        <p className="text-sm text-slate-500 mb-6">
          Aucun montant n'a été débité. Vous pouvez réessayer à tout moment.
        </p>
        <button
          data-testid="payment-cancel-billing"
          onClick={() => navigate("/billing")}
          className="w-full bg-brand-navy text-white font-semibold rounded-lg px-4 py-3 hover:bg-brand-blue transition-colors"
        >
          Retour à la facturation
        </button>
      </div>
    </div>
  );
}
